import { render, staticRenderFns } from "./ProductSelector.vue?vue&type=template&id=e481dd9a&scoped=true"
import script from "./ProductSelector.vue?vue&type=script&lang=ts"
export * from "./ProductSelector.vue?vue&type=script&lang=ts"
import style0 from "./ProductSelector.vue?vue&type=style&index=0&id=e481dd9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e481dd9a",
  null
  
)

export default component.exports